module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('affiliate')))]), _vm._v(" > "), _c('span', [_vm._v(_vm._s(_vm.$t('withdrawDetails')))])]), _vm._v(" "), (_vm.records.length === 0 && !_vm.loading) ? _c('div', {
    staticClass: "no-record"
  }, [_vm._v(_vm._s(_vm.$t('noRecords')))]) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.records), function(item) {
    return _c('div', {
      staticClass: "phone-records"
    }, [_c('p', {
      staticClass: "account"
    }, [_vm._v(_vm._s(item.payment_id))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('time')) + _vm._s(_vm.$t(':')) + _vm._s(_vm._f("createFormatTime")(item.created_at, item.created_at)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('amount')) + _vm._s(_vm.$t(':')) + _vm._s(_vm.$t(item.currency_code)) + " " + _vm._s(item[item.currency_code]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('status')) + _vm._s(_vm.$t(':')) + _vm._s(_vm.$t(item.status)))])])
  }), 0), _vm._v(" "), _c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('back-to-top'), _vm._v(" "), _c('load-more', {
    attrs: {
      "current-page": _vm.currentPage,
      "total-page": _vm.totalPage,
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.queryRecords($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-706c6080!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/withdrawDetails/withdrawDetailsM.vue
// module id = 1350
// module chunks = 1